import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "1dd0777d-a2c2-473a-8f79-558d0025a1da"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter1dd0777dA2c2473a8f79558d0025a1da(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultFooter1dd0777dA2c2473a8f79558d0025a1da footer`}>
      {props["links"] || <Navigation className="LinksEdd0479eA42c44409f0327b0a9ec1d23" parentTag={buildClassName("LinksEdd0479eA42c44409f0327b0a9ec1d23", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoE779f1d02e684d0eBf9a1df00b7fc15d" parentTag={buildClassName("LogoE779f1d02e684d0eBf9a1df00b7fc15d", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright7f196ce0A36f4442B65d312d77f3cd9c" parentTag={buildClassName("Copyright7f196ce0A36f4442B65d312d77f3cd9c", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow48ca3aa7A61e4666AaedC31230901e8b" parentTag={buildClassName("Groupflow48ca3aa7A61e4666AaedC31230901e8b", parentTag)} {...props} />}
    </div>
  );
}

// id: "2a8e36f3-211e-4c34-97c1-636c46d1a665"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoBcf953d3E0a0463581a93981b7acc731" parentTag={buildClassName("LinkedLogoBcf953d3E0a0463581a93981b7acc731", parentTag)} label={<Logo className="LabelF67b455f748748429cdc31ce73e2f23f" parentTag={buildClassName("LabelF67b455f748748429cdc31ce73e2f23f", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation77840cc9Bbff44ebA2ae23f7dc171605" parentTag={buildClassName("Navigation77840cc9Bbff44ebA2ae23f7dc171605", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "ea95734a-07e1-4ae2-8ba1-b2c9dbb76297"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageEa95734a07e14ae28ba1B2c9dbb76297(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageEa95734a07e14ae28ba1B2c9dbb76297 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderD8c048e6486d42b890cd55c38e3573e4" title="About Us" {...props} />}
      {props["main"] || <Main3af93e6649534d7cA4f73705e1cf9820 />}
      {props["footer"] || <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterC5cdf2b7F68f42e891d43b017421b799" {...props} />}
    </div>
  );
}

// id: "92bc8d59-c391-41b8-8e25-bd6248d67935"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage92bc8d59C39141b88e25Bd6248d67935(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage92bc8d59C39141b88e25Bd6248d67935`}>
      {props["header"] || <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderCb4c8326B13946af80fdF16b105fa5d4" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterB52a3148Fdfa44909f20Fc698ca8ef25" {...props} />}
    </div>
  );
}

// id: "1f9f946d-e2d2-4173-b369-6de0262d4a56"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage1f9f946dE2d24173B3696de0262d4a56(props: any) {
  return (
    <SecondaryPage63c4b163412e415eA9a21398eeae3c08 parentTag="JoinUsPage1f9f946dE2d24173B3696de0262d4a56" header={<SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderE9cce46a7f834043B8a8Ac94fe7cbbc6" title="Join Us" />} {...props} />
  );
}

// id: "23de6e93-c07e-4777-ab12-2512953bacdd"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages23de6e93C07e4777Ab122512953bacdd(props: any) {
  return (
    <SecondaryPage63c4b163412e415eA9a21398eeae3c08 parentTag="ApplicationPages23de6e93C07e4777Ab122512953bacdd" header={<SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderF8aa0c69168c4b98914899db67c6b36c" title="Join Us" />} {...props} />
  );
}

// id: "63c4b163-412e-415e-a9a2-1398eeae3c08"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage63c4b163412e415eA9a21398eeae3c08(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage63c4b163412e415eA9a21398eeae3c08`}>
      {props["header"] || <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderB832187aF1794a36816b2bfa616b44b2" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="Footer8b0976e25245438785e7804e77876e64" {...props} />}
    </div>
  );
}

// id: "ebd8cfbd-4ae2-4a79-9f6c-509004cb9ea6"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroEbd8cfbd4ae24a799f6c509004cb9ea6(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroEbd8cfbd4ae24a799f6c509004cb9ea6 hero`}>
      <h1 className="title">
        {props["title"] || Title6ad835dfE9a54685A8a613812365159a}
      </h1>
    </div>
  );
}

// id: "949c9315-8cd3-42b0-b680-94b42191d453"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage949c93158cd342b0B68094b42191d453(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage949c93158cd342b0B68094b42191d453 gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapperAf9ebd199b0c4fecBf95A5ec0dfbd2d1 />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6" parentTag={buildClassName("WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6", parentTag)} {...props} />}
      {props["main"] || <Main860ada1319d240e392e75d07564e05fc />}
      {props["quote"] || <PageQuote className="Quote12044c2e183345d1928d7d3330d28a93" parentTag={buildClassName("Quote12044c2e183345d1928d7d3330d28a93", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterE9bef0445d324a5f9bb7A039bf46f44a" {...props} />}
    </div>
  );
}

// id: "48ca3aa7-a61e-4666-aaed-c31230901e8b"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "1dd0777d-a2c2-473a-8f79-558d0025a1da"
export function Groupflow48ca3aa7A61e4666AaedC31230901e8b(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow48ca3aa7A61e4666AaedC31230901e8b" parentTag={buildClassName("Groupflow48ca3aa7A61e4666AaedC31230901e8b", parentTag)} {...props} />
  );
}

// id: "9a6f1528-1aa8-488e-a094-8866afec730d"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "2a8e36f3-211e-4c34-97c1-636c46d1a665"
export function Logo9a6f15281aa8488eA0948866afec730d(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo9a6f15281aa8488eA0948866afec730d" parentTag={buildClassName("Logo9a6f15281aa8488eA0948866afec730d", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "f0f2451a-a1aa-49eb-8c07-63c28b6ea652"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "dde9275a-37fe-4ce3-9857-48d67c799d38"
export function HeaderTopF0f2451aA1aa49eb8c0763c28b6ea652(props: any) {
  return (
    <DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665 parentTag="HeaderTopF0f2451aA1aa49eb8c0763c28b6ea652" {...props} />
  );
}

// id: "e779f1d0-2e68-4d0e-bf9a-1df00b7fc15d"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "1dd0777d-a2c2-473a-8f79-558d0025a1da"
export function LogoE779f1d02e684d0eBf9a1df00b7fc15d(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoE779f1d02e684d0eBf9a1df00b7fc15d" parentTag={buildClassName("LogoE779f1d02e684d0eBf9a1df00b7fc15d", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "b52a3148-fdfa-4490-9f20-fc698ca8ef25"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "92bc8d59-c391-41b8-8e25-bd6248d67935"
export function FooterB52a3148Fdfa44909f20Fc698ca8ef25(props: any) {
  return (
    <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterB52a3148Fdfa44909f20Fc698ca8ef25" {...props} />
  );
}

// id: "bcf953d3-e0a0-4635-81a9-3981b7acc731"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "2a8e36f3-211e-4c34-97c1-636c46d1a665"
export function LinkedLogoBcf953d3E0a0463581a93981b7acc731(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoBcf953d3E0a0463581a93981b7acc731" parentTag={buildClassName("LinkedLogoBcf953d3E0a0463581a93981b7acc731", parentTag)} label={<Logo className="LabelF67b455f748748429cdc31ce73e2f23f" parentTag={buildClassName("LabelF67b455f748748429cdc31ce73e2f23f", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />
  );
}

// id: "6ad835df-e9a5-4685-a8a6-13812365159a"
// title: ""
// type: :text
// key: "title"
// parent_id: "ebd8cfbd-4ae2-4a79-9f6c-509004cb9ea6"
export const Title6ad835dfE9a54685A8a613812365159a = "Default Title";

// id: "860ada13-19d2-40e3-92e7-5d07564e05fc"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "949c9315-8cd3-42b0-b680-94b42191d453"
export function Main860ada1319d240e392e75d07564e05fc(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main860ada1319d240e392e75d07564e05fc`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards1faaa8094316443e9ad04c726bfccaca" parentTag={buildClassName("Cards1faaa8094316443e9ad04c726bfccaca", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "125d3ea9-2e2a-4157-a3fd-c10fd2118fb6"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "949c9315-8cd3-42b0-b680-94b42191d453"
export function WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6" parentTag={buildClassName("WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6", parentTag)} {...props} />
  );
}

// id: "3af93e66-4953-4d7c-a4f7-3705e1cf9820"
// title: ""
// type: :html
// key: "main"
// parent_id: "ea95734a-07e1-4ae2-8ba1-b2c9dbb76297"
export function Main3af93e6649534d7cA4f73705e1cf9820(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main3af93e6649534d7cA4f73705e1cf9820`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards5bf58c5cEf1e44418be8A36749f9c7b2" parentTag={buildClassName("Cards5bf58c5cEf1e44418be8A36749f9c7b2", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "f8aa0c69-168c-4b98-9148-99db67c6b36c"
// title: ""
// type: :reference
// key: "header"
// parent_id: "23de6e93-c07e-4777-ab12-2512953bacdd"
export function HeaderF8aa0c69168c4b98914899db67c6b36c(props: any) {
  return (
    <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderF8aa0c69168c4b98914899db67c6b36c" title="Join Us" {...props} />
  );
}

// id: "77840cc9-bbff-44eb-a2ae-23f7dc171605"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "2a8e36f3-211e-4c34-97c1-636c46d1a665"
export function Navigation77840cc9Bbff44ebA2ae23f7dc171605(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation77840cc9Bbff44ebA2ae23f7dc171605" parentTag={buildClassName("Navigation77840cc9Bbff44ebA2ae23f7dc171605", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "e9cce46a-7f83-4043-b8a8-ac94fe7cbbc6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1f9f946d-e2d2-4173-b369-6de0262d4a56"
export function HeaderE9cce46a7f834043B8a8Ac94fe7cbbc6(props: any) {
  return (
    <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderE9cce46a7f834043B8a8Ac94fe7cbbc6" title="Join Us" {...props} />
  );
}

// id: "cb4c8326-b139-46af-80fd-f16b105fa5d4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "92bc8d59-c391-41b8-8e25-bd6248d67935"
export function HeaderCb4c8326B13946af80fdF16b105fa5d4(props: any) {
  return (
    <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderCb4c8326B13946af80fdF16b105fa5d4" title="Public Events" {...props} />
  );
}

// id: "b042d5ec-140b-4999-ad24-61104b32526b"
// title: ""
// type: :text
// key: "title"
// parent_id: "dde9275a-37fe-4ce3-9857-48d67c799d38"
export const TitleB042d5ec140b4999Ad2461104b32526b = "Secondary Marketing Title 1";

// id: "edd0479e-a42c-4440-9f03-27b0a9ec1d23"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "1dd0777d-a2c2-473a-8f79-558d0025a1da"
export function LinksEdd0479eA42c44409f0327b0a9ec1d23(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksEdd0479eA42c44409f0327b0a9ec1d23" parentTag={buildClassName("LinksEdd0479eA42c44409f0327b0a9ec1d23", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "b832187a-f179-4a36-816b-2bfa616b44b2"
// title: ""
// type: :reference
// key: "header"
// parent_id: "63c4b163-412e-415e-a9a2-1398eeae3c08"
export function HeaderB832187aF1794a36816b2bfa616b44b2(props: any) {
  return (
    <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderB832187aF1794a36816b2bfa616b44b2" title="Secondary Page" {...props} />
  );
}

// id: "c5cdf2b7-f68f-42e8-91d4-3b017421b799"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "ea95734a-07e1-4ae2-8ba1-b2c9dbb76297"
export function FooterC5cdf2b7F68f42e891d43b017421b799(props: any) {
  return (
    <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterC5cdf2b7F68f42e891d43b017421b799" {...props} />
  );
}

// id: "b12aa3cd-1fe3-43ae-9de6-823644a23c98"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "dde9275a-37fe-4ce3-9857-48d67c799d38"
export function HeroB12aa3cd1fe343ae9de6823644a23c98(props: any) {
  return (
    <SecondaryMarketingHeroEbd8cfbd4ae24a799f6c509004cb9ea6 parentTag="HeroB12aa3cd1fe343ae9de6823644a23c98" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "d8c048e6-486d-42b8-90cd-55c38e3573e4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "ea95734a-07e1-4ae2-8ba1-b2c9dbb76297"
export function HeaderD8c048e6486d42b890cd55c38e3573e4(props: any) {
  return (
    <SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 parentTag="HeaderD8c048e6486d42b890cd55c38e3573e4" title="About Us" {...props} />
  );
}

// id: "8b0976e2-5245-4387-85e7-804e77876e64"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "63c4b163-412e-415e-a9a2-1398eeae3c08"
export function Footer8b0976e25245438785e7804e77876e64(props: any) {
  return (
    <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="Footer8b0976e25245438785e7804e77876e64" {...props} />
  );
}

// id: "7f196ce0-a36f-4442-b65d-312d77f3cd9c"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "1dd0777d-a2c2-473a-8f79-558d0025a1da"
export function Copyright7f196ce0A36f4442B65d312d77f3cd9c(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright7f196ce0A36f4442B65d312d77f3cd9c" parentTag={buildClassName("Copyright7f196ce0A36f4442B65d312d77f3cd9c", parentTag)} {...props} />
  );
}

// id: "12044c2e-1833-45d1-928d-7d3330d28a93"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "949c9315-8cd3-42b0-b680-94b42191d453"
export function Quote12044c2e183345d1928d7d3330d28a93(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote12044c2e183345d1928d7d3330d28a93" parentTag={buildClassName("Quote12044c2e183345d1928d7d3330d28a93", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "e9bef044-5d32-4a5f-9bb7-a039bf46f44a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "949c9315-8cd3-42b0-b680-94b42191d453"
export function FooterE9bef0445d324a5f9bb7A039bf46f44a(props: any) {
  return (
    <DefaultFooter1dd0777dA2c2473a8f79558d0025a1da parentTag="FooterE9bef0445d324a5f9bb7A039bf46f44a" {...props} />
  );
}

// id: "f67b455f-7487-4842-9cdc-31ce73e2f23f"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "bcf953d3-e0a0-4635-81a9-3981b7acc731"
export function LabelF67b455f748748429cdc31ce73e2f23f(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelF67b455f748748429cdc31ce73e2f23f" parentTag={buildClassName("LabelF67b455f748748429cdc31ce73e2f23f", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "009a85f9-4be2-4eeb-acc2-e2dc27b74e86"
// title: ""
// type: :text
// key: "class"
// parent_id: "77840cc9-bbff-44eb-a2ae-23f7dc171605"
export const Class009a85f94be24eebAcc2E2dc27b74e86 = "navigation";

// id: "e2b40861-4ec5-46b3-97f2-c990b19ebcc0"
// title: ""
// type: :text
// key: "class"
// parent_id: "bcf953d3-e0a0-4635-81a9-3981b7acc731"
export const ClassE2b408614ec546b397f2C990b19ebcc0 = "linked-logo";

// id: "1dc7ba08-3523-46d3-b257-35a1d1ac0326"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "af9ebd19-9b0c-4fec-bf95-a5ec0dfbd2d1"
export function HeroWrapper1dc7ba08352346d3B25735a1d1ac0326(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper1dc7ba08352346d3B25735a1d1ac0326`}>
      {props["hero"] || <Hero className="Hero235bcfea2f3f47d286265d380cbc9fa3" parentTag={buildClassName("Hero235bcfea2f3f47d286265d380cbc9fa3", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "5bf58c5c-ef1e-4441-8be8-a36749f9c7b2"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "3af93e66-4953-4d7c-a4f7-3705e1cf9820"
export function Cards5bf58c5cEf1e44418be8A36749f9c7b2(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards5bf58c5cEf1e44418be8A36749f9c7b2" parentTag={buildClassName("Cards5bf58c5cEf1e44418be8A36749f9c7b2", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "a7edb276-bd25-4cd9-8c2f-568531264e7e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "12044c2e-1833-45d1-928d-7d3330d28a93"
export const ContentSlugA7edb276Bd254cd98c2f568531264e7e = "home-page-quote";

// id: "a65dd794-9c4c-4a29-8d0f-9e37ac6a8c03"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "af9ebd19-9b0c-4fec-bf95-a5ec0dfbd2d1"
export function HeaderTopA65dd7949c4c4a298d0f9e37ac6a8c03(props: any) {
  return (
    <DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665 parentTag="HeaderTopA65dd7949c4c4a298d0f9e37ac6a8c03" {...props} />
  );
}

// id: "45675f78-bbf3-43a9-bdec-6f14e1a019c0"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "9a6f1528-1aa8-488e-a094-8866afec730d"
export const LogoType45675f78Bbf343a9Bdec6f14e1a019c0 = "DEFAULT";

// id: "47deddd4-da25-4f74-ae14-758d994dcd68"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "77840cc9-bbff-44eb-a2ae-23f7dc171605"
export const NavMenuSlug47deddd4Da254f74Ae14758d994dcd68 = "marketing-primary-nav";

// id: "d399966e-eb10-49eb-8920-e4014742c3e8"
// title: ""
// type: :text
// key: "title"
// parent_id: "b832187a-f179-4a36-816b-2bfa616b44b2"
export const TitleD399966eEb1049eb8920E4014742c3e8 = "Secondary Page";

// id: "1c1af456-a6d5-4382-b030-e65fe4ad0cfc"
// title: ""
// type: :text
// key: "title"
// parent_id: "cb4c8326-b139-46af-80fd-f16b105fa5d4"
export const Title1c1af456A6d54382B030E65fe4ad0cfc = "Public Events";

// id: "bce6d598-7bf3-4f9e-8158-608de89a19c0"
// title: ""
// type: :text
// key: "url"
// parent_id: "bcf953d3-e0a0-4635-81a9-3981b7acc731"
export const UrlBce6d5987bf34f9e8158608de89a19c0 = "/";

// id: "1faaa809-4316-443e-9ad0-4c726bfccaca"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "860ada13-19d2-40e3-92e7-5d07564e05fc"
export function Cards1faaa8094316443e9ad04c726bfccaca(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards1faaa8094316443e9ad04c726bfccaca" parentTag={buildClassName("Cards1faaa8094316443e9ad04c726bfccaca", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "22d470b9-b4e3-4aa1-9a16-b24cc9e72822"
// title: ""
// type: :text
// key: "title"
// parent_id: "e9cce46a-7f83-4043-b8a8-ac94fe7cbbc6"
export const Title22d470b9B4e34aa19a16B24cc9e72822 = "Join Us";

// id: "ff8899cf-a01d-4fd0-a85b-5583ff5923dc"
// title: ""
// type: :text
// key: "title"
// parent_id: "f8aa0c69-168c-4b98-9148-99db67c6b36c"
export const TitleFf8899cfA01d4fd0A85b5583ff5923dc = "Join Us";

// id: "7678d207-d9d1-4949-a5d4-f5aea25c6088"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "edd0479e-a42c-4440-9f03-27b0a9ec1d23"
export const NavMenuSlug7678d207D9d14949A5d4F5aea25c6088 = "footer-nav";

// id: "0076ceca-54a5-4a64-93d4-8a0555e345e1"
// title: ""
// type: :text
// key: "title"
// parent_id: "d8c048e6-486d-42b8-90cd-55c38e3573e4"
export const Title0076ceca54a54a6493d48a0555e345e1 = "About Us";

// id: "a06ec0c6-e463-4dd6-9f0b-3c8b8a22d618"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "e779f1d0-2e68-4d0e-bf9a-1df00b7fc15d"
export const LogoTypeA06ec0c6E4634dd69f0b3c8b8a22d618 = "FOOTER";

// id: "efb9bf0c-5102-45c7-9fba-51f985902481"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e779f1d0-2e68-4d0e-bf9a-1df00b7fc15d"
export const ContentSlugEfb9bf0c510245c79fba51f985902481 = "footer-logo";

// id: "8040a886-b6c8-45c6-a049-1203a6070d46"
// title: ""
// type: :text
// key: "title"
// parent_id: "b12aa3cd-1fe3-43ae-9de6-823644a23c98"
export const Title8040a886B6c845c6A0491203a6070d46 = "Secondary Marketing Title 2";

// id: "d24f8d82-9bbd-44bd-abbb-7389b042cb76"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "1faaa809-4316-443e-9ad0-4c726bfccaca"
export const ButtonClassD24f8d829bbd44bdAbbb7389b042cb76 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "c77028b1-ac8f-44e3-b861-c7d888383642"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "1faaa809-4316-443e-9ad0-4c726bfccaca"
export const PostSlugC77028b1Ac8f44e3B861C7d888383642 = "home-page-cards";

// id: "235bcfea-2f3f-47d2-8626-5d380cbc9fa3"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "1dc7ba08-3523-46d3-b257-35a1d1ac0326"
export function Hero235bcfea2f3f47d286265d380cbc9fa3(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero235bcfea2f3f47d286265d380cbc9fa3" parentTag={buildClassName("Hero235bcfea2f3f47d286265d380cbc9fa3", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "d0f5c587-4a33-4bf9-ace2-ea98fbba7875"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "f67b455f-7487-4842-9cdc-31ce73e2f23f"
export const LogoTypeD0f5c5874a334bf9Ace2Ea98fbba7875 = "DEFAULT";

// id: "09f1105c-b041-44b7-ba5e-998267ec12f9"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "5bf58c5c-ef1e-4441-8be8-a36749f9c7b2"
export const PostSlug09f1105cB04144b7Ba5e998267ec12f9 = "about-us-cards";

// id: "5d93eaf2-e20c-46d4-8591-e1df26ea6268"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "f67b455f-7487-4842-9cdc-31ce73e2f23f"
export const ContentSlug5d93eaf2E20c46d48591E1df26ea6268 = "header-logo";

// id: "79e47e4a-4e57-4846-8782-2642364d8bb0"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "235bcfea-2f3f-47d2-8626-5d380cbc9fa3"
export const PostSlug79e47e4a4e57484687822642364d8bb0 = "home-hero";

// id: "af9ebd19-9b0c-4fec-bf95-a5ec0dfbd2d1"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "949c9315-8cd3-42b0-b680-94b42191d453"
export function HeaderWrapperAf9ebd199b0c4fecBf95A5ec0dfbd2d1(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapperAf9ebd199b0c4fecBf95A5ec0dfbd2d1`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665 parentTag="HeaderTopA65dd7949c4c4a298d0f9e37ac6a8c03" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper1dc7ba08352346d3B25735a1d1ac0326 />}
    </div>
  );
}

// id: "dde9275a-37fe-4ce3-9857-48d67c799d38"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665 parentTag="HeaderTopF0f2451aA1aa49eb8c0763c28b6ea652" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroEbd8cfbd4ae24a799f6c509004cb9ea6 parentTag="HeroB12aa3cd1fe343ae9de6823644a23c98" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

const Components = {
  DefaultFooter1dd0777dA2c2473a8f79558d0025a1da,
  DefaultHeaderTop2a8e36f3211e4c3497c1636c46d1a665,
  AboutUsPageEa95734a07e14ae28ba1B2c9dbb76297,
  PublicEventsPage92bc8d59C39141b88e25Bd6248d67935,
  JoinUsPage1f9f946dE2d24173B3696de0262d4a56,
  ApplicationPages23de6e93C07e4777Ab122512953bacdd,
  SecondaryPage63c4b163412e415eA9a21398eeae3c08,
  SecondaryMarketingHeroEbd8cfbd4ae24a799f6c509004cb9ea6,
  HomePage949c93158cd342b0B68094b42191d453,
  Groupflow48ca3aa7A61e4666AaedC31230901e8b,
  Logo9a6f15281aa8488eA0948866afec730d,
  HeaderTopF0f2451aA1aa49eb8c0763c28b6ea652,
  LogoE779f1d02e684d0eBf9a1df00b7fc15d,
  FooterB52a3148Fdfa44909f20Fc698ca8ef25,
  LinkedLogoBcf953d3E0a0463581a93981b7acc731,
  Title6ad835dfE9a54685A8a613812365159a,
  Main860ada1319d240e392e75d07564e05fc,
  WelcomeBack125d3ea92e2a4157A3fdC10fd2118fb6,
  Main3af93e6649534d7cA4f73705e1cf9820,
  HeaderF8aa0c69168c4b98914899db67c6b36c,
  Navigation77840cc9Bbff44ebA2ae23f7dc171605,
  HeaderE9cce46a7f834043B8a8Ac94fe7cbbc6,
  HeaderCb4c8326B13946af80fdF16b105fa5d4,
  TitleB042d5ec140b4999Ad2461104b32526b,
  LinksEdd0479eA42c44409f0327b0a9ec1d23,
  HeaderB832187aF1794a36816b2bfa616b44b2,
  FooterC5cdf2b7F68f42e891d43b017421b799,
  HeroB12aa3cd1fe343ae9de6823644a23c98,
  HeaderD8c048e6486d42b890cd55c38e3573e4,
  Footer8b0976e25245438785e7804e77876e64,
  Copyright7f196ce0A36f4442B65d312d77f3cd9c,
  Quote12044c2e183345d1928d7d3330d28a93,
  FooterE9bef0445d324a5f9bb7A039bf46f44a,
  LabelF67b455f748748429cdc31ce73e2f23f,
  Class009a85f94be24eebAcc2E2dc27b74e86,
  ClassE2b408614ec546b397f2C990b19ebcc0,
  HeroWrapper1dc7ba08352346d3B25735a1d1ac0326,
  Cards5bf58c5cEf1e44418be8A36749f9c7b2,
  ContentSlugA7edb276Bd254cd98c2f568531264e7e,
  HeaderTopA65dd7949c4c4a298d0f9e37ac6a8c03,
  LogoType45675f78Bbf343a9Bdec6f14e1a019c0,
  NavMenuSlug47deddd4Da254f74Ae14758d994dcd68,
  TitleD399966eEb1049eb8920E4014742c3e8,
  Title1c1af456A6d54382B030E65fe4ad0cfc,
  UrlBce6d5987bf34f9e8158608de89a19c0,
  Cards1faaa8094316443e9ad04c726bfccaca,
  Title22d470b9B4e34aa19a16B24cc9e72822,
  TitleFf8899cfA01d4fd0A85b5583ff5923dc,
  NavMenuSlug7678d207D9d14949A5d4F5aea25c6088,
  Title0076ceca54a54a6493d48a0555e345e1,
  LogoTypeA06ec0c6E4634dd69f0b3c8b8a22d618,
  ContentSlugEfb9bf0c510245c79fba51f985902481,
  Title8040a886B6c845c6A0491203a6070d46,
  ButtonClassD24f8d829bbd44bdAbbb7389b042cb76,
  PostSlugC77028b1Ac8f44e3B861C7d888383642,
  Hero235bcfea2f3f47d286265d380cbc9fa3,
  LogoTypeD0f5c5874a334bf9Ace2Ea98fbba7875,
  PostSlug09f1105cB04144b7Ba5e998267ec12f9,
  ContentSlug5d93eaf2E20c46d48591E1df26ea6268,
  PostSlug79e47e4a4e57484687822642364d8bb0,
  HeaderWrapperAf9ebd199b0c4fecBf95A5ec0dfbd2d1,
  SecondaryMarketingHeaderDde9275a37fe4ce3985748d67c799d38
}

export default Components;